import React from 'react';
import type { HeroBannerProps, TextColorMode } from '@noths/polaris-client-ribbons-design-system';
import { HeroBanner } from '@noths/polaris-client-ribbons-design-system';
import parse from 'html-react-parser';

import { trackLinkClick } from '../../../tracking/common/banner';
import { trackImpression } from '../../../tracking/common/trackImpression';
import type { TrackingContext } from '../../../types/TrackingContext';
import { SectionContainer } from '../../molecules/SectionContainer';
import * as styles from './HeroBannerSection.style';

const parseOptionalHtmlString = (html: string) => {
  const reactNodes = parse(html);
  return !Array.isArray(reactNodes) ? reactNodes : undefined;
};

export interface HeroBannerSectionProps extends HeroBannerProps {
  trackingTitle: string;
  trackingPosition?: number;
  subHeading?: string;
  copy?: string;
}

export const HeroBannerSection = ({
  copy,
  subHeading,
  trackingPosition,
  trackingTitle,
  ...restOfProps
}: HeroBannerSectionProps) => {
  const trackingContext: TrackingContext = {
    trackingPosition,
    trackingTitle,
    trackingContentType: 'Hero banner',
  };

  return (
    <SectionContainer wrapperStyles={styles.wrapper}>
      <HeroBanner
        subHeading={subHeading && parseOptionalHtmlString(subHeading)}
        copy={copy && parseOptionalHtmlString(copy)}
        onVisible={() => trackImpression(trackingContext)}
        onButtonClick={(e: React.MouseEvent<HTMLAnchorElement>) =>
          trackLinkClick(e, trackingContext, 'CTA')
        }
        onLinkClick={(e: React.MouseEvent) => trackLinkClick(e, trackingContext, 'Link')}
        {...restOfProps}
      />
    </SectionContainer>
  );
};

export type { HeroBannerProps, TextColorMode };
